import { useSignupStep } from 'modules/auth/hooks/useSignupStep'
import { EnumAuthTrackingEvents } from 'modules/auth/lib/tracking/events'
import { Button } from 'modules/common/components/_ui/Button/Button'
import { useTranslation } from 'modules/common/hooks/useTranslation'
import { trackEvent } from 'modules/common/lib/amplitude/trackEvent'

interface Props {
  event?: EnumAuthTrackingEvents
  isNextButtonLoading?: boolean
  isNextButtonDisabled?: boolean
  nextButtonLabel?: string
}
export const SignupFormActions = ({
  event,
  isNextButtonLoading,
  isNextButtonDisabled,
  nextButtonLabel,
}: Props) => {
  const { t } = useTranslation(['common'])
  const { hasNextStep, hasPreviousStep, goToPreviousStep } = useSignupStep()

  return (
    <div className="flex gap-4">
      <div className="hidden flex-1 md:block">
        {hasPreviousStep && (
          <Button
            variant="secondary"
            color="default"
            type="button"
            className="w-full"
            onClick={goToPreviousStep}
            data-testid="signup-form-actions-back"
          >
            {t('previous')}
          </Button>
        )}
      </div>
      <div className="flex-1">
        {hasNextStep && (
          <Button
            data-testid="signup-submit-button"
            variant="primary"
            color="default"
            type="submit"
            disabled={isNextButtonDisabled}
            className="w-full"
            isLoading={isNextButtonLoading}
            onClick={() =>
              event &&
              trackEvent({
                eventType: event,
              })
            }
          >
            {nextButtonLabel || t('next')}
          </Button>
        )}
      </div>
    </div>
  )
}
